import React from 'react';

// Sample blog posts data
const blogPosts = [
  {
    id: 1,
    title: "The Rise of Social Commerce",
    excerpt: "Explore how social platforms are becoming powerful sales channels.",
    image: "/placeholder.svg", // Update the image path as needed
    category: "Social Media",
    date: "Mar 5, 2024",
    author: "John Doe",
    readMoreLink: "#",
  },
  {
    id: 2,
    title: "SEO in 2024: What You Need to Know",
    excerpt: "Discover key SEO trends to improve your website's rankings.",
    image: "/placeholder.svg",
    category: "SEO",
    date: "Mar 3, 2024",
    author: "Jane Smith",
    readMoreLink: "#",
  },
  // Add more posts as needed...
];

export function BlogPosts() {
  return (
    <section>
      {/* Section Heading */}
      <h2 className="text-2xl font-semibold mb-6">Latest Posts</h2>

      {/* Blog Cards - Horizontal Scrolling */}
      <div className="overflow-x-auto">
        <div className="flex space-x-4 px-4">
          {blogPosts.map((post) => (
            <div
              key={post.id}
              className="border rounded-lg shadow-lg p-4 transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl bg-white min-w-[250px]"
            >
              <div className="relative">
                {/* Blog Image */}
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-40 object-cover rounded-md transition-transform duration-300 hover:scale-110"
                />
                {/* Category Tag */}
                <span className="bg-blue-500 text-white text-sm px-2 py-1 rounded absolute top-2 left-2">
                  {post.category}
                </span>
              </div>
              {/* Blog Content */}
              <h3 className="mt-4 font-semibold text-lg hover:text-blue-600 transition">
                {post.title}
              </h3>
              <p className="text-gray-500 text-sm mt-2">
                POSTED BY{" "}
                <a href="#" className="text-blue-600 hover:text-blue-800">
                  {post.author}
                </a>
              </p>
              <a
                href={post.readMoreLink}
                className="text-blue-600 mt-2 block hover:text-blue-800 transition"
              >
                READ MORE
              </a>
              <p className="text-gray-500 text-sm mt-1">{post.date}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Load More Button */}
      <div className="mt-8 text-center">
        <button className="py-3 px-6 bg-blue-500 text-white text-lg font-semibold rounded-md hover:bg-blue-600">
          Load More Posts
        </button>
      </div>
    </section>
  );
}
